import DjangoClient from '../tn.django/django-client.service/djangoClient';

export class EulaModel {
    public id?: number;
    public slug?: string;
    public eula_title?: string;
    public eula_subtitle?: string;
    public preface?: string;
    public eula?: string;
    public eula_web?: string;
    public eula_web_self_hosted?: string;
    public eula_epub?: string;
    public eula_app?: string;
    public eula_desktop?: string;
    public eula_game?: string;
    public eula_broadcast?: string;
    public eula_embedding?: string;
    public eula_server?: string;
    public postface?: string;
    public default = false;
}

export class EulaService {
    public static $inject = ['djangoClient'];

    public constructor(protected djangoClient: DjangoClient) {}

    async getEula(slug: string): Promise<EulaModel> {
        return this.djangoClient.get<EulaModel>(`/api/1/eulas/${slug}/`);
    }
}
